import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TypeofcollegeListComponent } from './typeofcollege-list/typeofcollege-list.component';
import { TypeofcollegeCreateComponent } from './typeofcollege-create/typeofcollege-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: TypeofcollegeListComponent,
        data: {
          title: "Type of College List",
          breadcrumb: "Typeofcollege List"
        }
      },
      {
        path: 'create',
        component: TypeofcollegeCreateComponent,
        data: {
          title: "Create Type of College",
          breadcrumb: "Create Typeofcollege"
        }
      },
      {
        path: 'edit/:id',
        component: TypeofcollegeCreateComponent,
        data: {
          title: "Edit Type of College",
          breadcrumb: "Edit Typeofcollege"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class TypeofcollegeRoutingModule { }
